module.exports = __webpack_public_path__ + "img/SKTC_E.c2bbf684.svg";